import { observer } from 'mobx-react-lite';
import { X } from 'lucide-react';
import { useStore } from '@shared/hooks/useStore';
import { OpenBook } from '@shared/types/reader';
import defaultCover from '@shared/assets/images/default-cover.png';
import ReaderMobileHeader from './ReaderMobileHeader';

interface ReaderTabsModalProps {
    isOpen: boolean,
    onClose: () => void,
    onTabClick?: (publicationId: string) => void,
    onTabClose?: (publicationId: string) => void
}

const ReaderTabsModal = observer(({ isOpen, onClose, onTabClick, onTabClose }: ReaderTabsModalProps) => {
    const { readerStore } = useStore();
    const { openBooks, activeBookId } = readerStore;

    if (!isOpen) return null;

    const handleTabClick = (book: OpenBook) => {
        readerStore.setActiveBook(book.publication.id);
        onTabClick?.(book.publication.id);
        onClose();
    };

    const handleTabClose = (e: React.MouseEvent, publicationId: string) => {
        e.stopPropagation();
        readerStore.removeBook(publicationId);
        onTabClose?.(publicationId);
    };

    return (
        <div className='fixed inset-0 z-50 bg-[#29292B] animate-fade-in'>
            <div className='h-full flex flex-col p-4 animate-slide-up'>
                <ReaderMobileHeader title='タブ' onClose={onClose} />

                {/* Tabs List */}
                <div className='flex-1 overflow-y-auto'>
                    <div className='flex flex-col gap-2'>
                        {openBooks.map((book) => {
                            const isActive = book.publication.id === activeBookId;
                            return (
                                <div
                                    key={book.publication.id}
                                    onClick={() => handleTabClick(book)}
                                    className={`flex gap-3 p-3 rounded-[10px] cursor-pointer transition-all text-white ${isActive ? 'bg-[#FFFFFF1A]' : 'hover:bg-[#FFFFFF1A]'}`}
                                >
                                    <img
                                        src={book.publication.linkImg}
                                        alt={book.publication.title}
                                        className='w-[39px] h-[52px] object-cover flex-shrink-0'
                                        onError={(e) => {
                                            e.currentTarget.src = defaultCover;
                                        }}
                                    />
                                    <div className='flex-1 min-w-0 flex flex-col justify-center'>
                                        <p className='text-sm font-semibold leading-[22px] truncate'>
                                            {book.publication.title}
                                        </p>
                                        <p className='text-[11px] leading-[22px] text-[#FFFFFF80]'>
                                            {book.currentPage || 1}
                                            /
                                            {book.publication.totalNumberPages}
                                            ページ
                                        </p>
                                    </div>
                                    <button
                                        onClick={e => handleTabClose(e, book.publication.id)}
                                        className='p-1 flex-shrink-0 self-center'
                                    >
                                        <X size={18} />
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ReaderTabsModal;
